module.exports = __webpack_public_path__ + "static/media/alentoursBackground.d412e3d9.jpg";